export const Products = {
  CheckoutProduct: 'CheckoutProduct',
  PeopleCountingProduct: 'PeopleCountingProduct',
  PeopleCountingGenderAgeProduct: 'PeopleCountingGenderAgeProduct',
  StaffCallProduct: 'StaffCallProduct',
  PersonnelTrackingProduct: 'PersonnelTrackingProduct',
  InstoreAnalyticsProduct: 'InstoreAnalyticsProduct'
};
